import { Model } from "@interfaces/model.interface";

export interface SupervisorRequestReason extends Model {
	isActive: boolean;
	reason: string;
}

export class SupervisorRequestReason implements SupervisorRequestReason {

	constructor(data?: Partial<SupervisorRequestReason>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}